import {
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
} from "@chakra-ui/react";
import { DocumentViewer, Props as DocumentViewerProps } from "./DocumentViewer";

type Props = {
  isOpen: boolean;
  onClose: () => void;
} & Omit<DocumentViewerProps, "onClose">;
export const DocumentViewerModal = ({
  isOpen,
  onClose,
  ...documentViewerProps
}: Props) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full" motionPreset="none">
      <ModalOverlay />
      <ModalContent bg="transparent">
        <ModalBody
          height="100%"
          width="100%"
          padding="0"
          paddingBlock="0"
          display="flex"
          alignItems="stretch"
          justifyContent="stretch"
          bg="transparent"
        >
          <Flex flexGrow="1" alignItems="center" justifyContent="center">
            <DocumentViewer onClose={onClose} {...documentViewerProps} />
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
